<script>
	// From Lucide
	import { ChevronFirst } from 'lucide-svelte';

	export let iconClass = '';
</script>

<ChevronFirst class={iconClass} />
